import { render } from "./Tratamiento.vue?vue&type=template&id=78fec6de&scoped=true"
import script from "./Tratamiento.vue?vue&type=script&lang=js"
export * from "./Tratamiento.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=78fec6de&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fec6de"]])

export default __exports__